export const UserRoles = {
    ADMIN: 'Admin',
    EMPLOYEE: 'Employee',
    CUSTOMER: 'Customer',
};
